module.exports = __webpack_public_path__ + "media/images/jad-ff-bg-mobile-67c5272c692c96db3dd64537c0e18fa9.png";